export enum ERedirectDB {
  FORGOT_PASSWORD = 'forgotPassword',
  INVITE = 'invite',
}

export enum ERedirectUI {
  FORGOT_PASSWORD = 'forgotPassword',
  INVITE = 'invite',
}
